import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { useAuth } from '@/src/app/hooks';
import { Menus } from '@/src/ui';
import { sanitizeGradeShortCode } from '@/src/utils';

// import AuthCallbackPage from '../pages/auth/authCallback/AuthCallbackPage';
import LoginRedirect from '@/src/pages/auth/login/LoginRedirect'; // ADD THIS

import DashboardPage from '@/src/pages/dashboard/DashboardPage';

import EBooksPage from '@/src/pages/eBooks/EBooksPage';
import LessonsPage from '@/src/pages/lessons/LessonsPage';

import AssessmentsPage from '@/src/pages/resources/assessments/AssessmentsPage';
import BTBFPage from '@/src/pages/resources/btbf/BTBFPage';
import ProfessionalLearningPage from '@/src/pages/resources/professionalLearning/ProfessionalLearningPage';

import UserGuidesPage from '@/src/pages/user/userGuides/UserGuidesPage';

// Routing & Auth
import NotAuthorizedPage from '@/src/app/components/NotAuthorizedPage';
// import NotFoundPage from '@/src/app/components/NotFoundPage';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Roles from './Roles';

const resourcesAllowedRoles = [
    Roles.SuperAdmin,
    Roles.DistrictAdmin,
    Roles.SchoolAdmin,
    Roles.Teacher,
    Roles.Coach,
];

function RoutesWrapper() {
    const { user, loading } = useAuth();
    useEffect(() => {
        const grade = sanitizeGradeShortCode(user?.gradeShortCode);
        document.documentElement.style.setProperty(
            '--scrollbar-color',
            `var(--pm-g${grade}-light)`
        );
    }, [user?.gradeShortCode]);

    return (
        <Routes>
            {/* <Route path="/authCallback" element={<AuthCallbackPage />} /> */}

            <Route element={<Menus />}>
                <Route element={<PublicRoute userExists={!!user} loading={loading} />}>
                    <Route path="login" element={<LoginRedirect />} />
                </Route>

                <Route
                    element={
                        <ProtectedRoute
                            allowedRoles={resourcesAllowedRoles}
                            user={user}
                            loading={loading}
                        />
                    }
                >
                    <Route path="dashboard" element={<DashboardPage />} />

                    <Route path="ebooks" element={<EBooksPage />} />
                    <Route path="lessons/:grade/:unit/:lesson" element={<LessonsPage />} />
                    <Route path="lessons/:grade/:unit" element={<LessonsPage />} />
                    <Route path="lessons/:grade?" element={<LessonsPage />} />

                    <Route path="resources/assessments/:grade?" element={<AssessmentsPage />} />
                    <Route path="resources/btbf" element={<BTBFPage />} />
                    <Route
                        path="resources/professionalLearning"
                        element={<ProfessionalLearningPage />}
                    />

                    <Route path="user/userGuides" element={<UserGuidesPage />} />
                </Route>

                <Route path="*" element={<Navigate to="/dashboard" replace />} />
                <Route path="not-authorized" element={<NotAuthorizedPage />} />
            </Route>
        </Routes>
    );
}

export default RoutesWrapper;
